<template>
<f7-app :params="f7params" >

  <!-- Left panel with cover effect-->
  <f7-panel left cover theme-dark :opened="leftOpened" @panel:opened="leftOpened = true" @panel:close="leftOpened = false">
    <settings @close="leftOpened = false" @open="leftOpened = true" />
  </f7-panel>

  <!-- Your main view, should have "view-main" class -->
  <f7-view main class="safe-areas" url="/"></f7-view>

</f7-app>
</template>
<script>
  import cordovaApp from '../js/cordova-app.js';
  import routes from '../js/routes.js';
  import Preferences from '../js/preferences.js';
  import RequestManager from '../js/request-manager.js';
  import Settings from '../components/settings.vue';

  export default {
    components: {
      settings: Settings
    },
    data() {
      return {
        // Framework7 Parameters
        f7params: {
          id: 'cz.oldanygroup.frekr.fw7', // App bundle ID
          name: 'Frekr.me', // App name
          theme: 'auto', // Automatic theme detection
          // App root data
          data: function () {
            return {};
          },

          // App routes
          routes: routes,
          pushState: true,
          pushStateRoot: '/m/',

          // Register service worker
          serviceWorker: this.$device.cordova ? {} : {
            path: '/m/service-worker.js',
          },
          // Input settings
          input: {
            scrollIntoViewOnFocus: this.$device.cordova && !this.$device.electron,
            scrollIntoViewCentered: this.$device.cordova && !this.$device.electron,
          },
          // Cordova Statusbar settings
          statusbar: {
            enabled: false,
            iosOverlaysWebView: true,
            androidOverlaysWebView: true,
          },
        },
        leftOpened: false,
      }
    },
    mounted() {
      this.$f7ready((f7) => {
        // Init cordova APIs (see cordova-app.js)
        if (f7.device.cordova) {
          cordovaApp.init(f7);
        }
        // Call F7 APIs here
        for (const workerReg of this.$f7.serviceWorker.registrations) workerReg.update();
        RequestManager.initialize();
        Preferences.init();
      });
    }
  }
</script>
